import React, { Fragment } from 'react';
import Grid from '@material-ui/core/Grid';
import TextInput from 'src/ui/library/TextInput';
import Button from 'src/ui/library/Button';
import intl from 'react-intl-universal';
import PropTypes from 'prop-types';

export const LoginForm = props => {
  const { hasError, loginStatus, onChange, isUserLocked, actionButton, blankEmail, blankPassword } = props;

  return (
    <Fragment>
      <Grid item lg={12} md={12} sm={12} xs={12} classes={{ container: '' }}>
        <TextInput
          id="loginemail"
          name="loginemail"
          autoComplete={'off'}
          label={intl.get('login.emailinput')}
          type="email"
          hasError={hasError}
          onChange={onChange}
          styleType={'login'}
          helperText={blankEmail ? intl.get('login.alert.noData.email.helperText') : ''}
        />
      </Grid>
      <Grid item lg={12} md={12} sm={12} xs={12} classes={{ container: '' }}>
        <TextInput
          autoComplete={'off'}
          id="loginpassword"
          helperText={blankPassword ? intl.get('login.alert.noData.password.helperText') : ''}
          name="loginpassword"
          label={intl.get('login.passwordinput')}
          type="password"
          hasError={hasError}
          onChange={onChange}
          styleType={'login'}
          onKeyPress={event => {
            if (event.key === 'Enter') actionButton(event);
          }}
        />
      </Grid>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Button onClick={actionButton} styleType={'login'} disabled={isUserLocked || loginStatus === 'PENDING'}>
          <span>{intl.get('login.loginbutton')}</span>
        </Button>
      </Grid>
    </Fragment>
  );
};

LoginForm.propTypes = {
  hasError: PropTypes.bool,
};

export default LoginForm;



// WEBPACK FOOTER //
// ./src/ui/features/Login/presentational/forms/LoginFormPres.js